import { Injectable, ErrorHandler } from '@angular/core';

@Injectable()
export class StorageService {
  constructor(private errorHandler: ErrorHandler) {}

  public get(key: string) {
    const result = localStorage.getItem(key);

    if (!result) {
      return null;
    }

    try {
      return JSON.parse(result);
    } catch (error) {
      console.error('StorageService.get can’t parse JSON', error);
      this.errorHandler.handleError(error);
      return null;
    }
  }

  public set(key: string, body: object | boolean) {
    localStorage.setItem(key, JSON.stringify(body));
  }
}
